import { reloadOnce } from "./reload-once";

export function connectStaleBuildReload() {
  window.addEventListener("vite:preloadError", (event) => {
    if (reloadOnce()) {
      event.preventDefault();
    }
  });
}
